import axios from 'axios';
import SessionService from '../services/SessionService';
import appCache from '../services/AppCache';

const SECTOR_ACCESS_DENIED_CODE = 'SECTOR_ACCESS_DENIED';
const SECTOR_ACCESS_DENIED_EVENT = 'sectorAccessDenied';

/**
 * Setup axios response interceptor to handle sector access denied (403).
 * When backend returns 403 with SECTOR_ACCESS_DENIED, clears the sector from session
 * and dispatches an event so the UI can update.
 */
export function setupAxiosInterceptors() {
  axios.interceptors.response.use(
    (response) => {
      const invalidateHeader = response.headers['x-cache-invalidate'] as string | undefined;
      if (invalidateHeader) {
        appCache.invalidateMany(invalidateHeader.split(',').map((p) => p.trim()).filter(Boolean));
      }
      return response;
    },
    (error) => {
      if (error.response?.status === 403) {
        const code = error.response?.data?.code;
        if (code === SECTOR_ACCESS_DENIED_CODE) {
          const revokedId = SessionService.getSectorId();
          SessionService.revokeSectorSelection(revokedId);
          window.dispatchEvent(new CustomEvent(SECTOR_ACCESS_DENIED_EVENT));
        }
      }
      return Promise.reject(error);
    }
  );
}
